import { TableHeader } from 'components/common/Table/Table';
import { ParserTypes } from './types';

export const PARSER_TYPES: ParserTypes = {
  UNDEFINED: { variant: 'error', name: 'Undefined' },
  BUILT_IN: { variant: 'custom', name: 'Built-in' },
  BUILT_IN_CUSTOM: { variant: 'modified', name: 'Built-in (modified)' },
  CUSTOM: { variant: 'success', name: 'Custom' },
};

export const HEADERS: Array<TableHeader> = [
  { content: 'Parser Name', field: 'name' },
  { content: 'Parser Type', field: 'type' },
  { content: 'Logs Using This Parser', field: 'logs' },
  { content: 'Actions', field: 'actions' },
];
